"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Linkedin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Label } from "@/components/ui/label";
const chefs = [{
  name: "Marinela Demrozi",
  role: "Founder & Marketing Director",
  bio: "Founder & Marketing Director - Lionia Project\n\n\nSono Marinela. Lavoro nel mondo della comunicazione da piu di 15 anni - con aziende, startup e professionisti che vogliono comunicare con piu chiarezza e piu coraggio. Lionia Project e il mio progetto piu personale: un luogo aperto dove le storie di comunicazione diventano ispirazione per tutti.",
  image: "https://lioniaproject.com/wp-content/uploads/2026/07/B79A9075-F590-433A-9123-80012ADA0394.jpg?v=tq6s85ycky",
  srcset: "https://lioniaproject.com/wp-content/uploads/2026/06/post-lionia-project-2025.jpg?v=rzezn7goz28-wvc-srcset",
  sizes: "https://lioniaproject.com/wp-content/uploads/2026/06/post-lionia-project-2025.jpg?v=za55wd7jj9-wvc-sizes",
  hasSocials: true
}];
export default function TheVisionary() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1418" id="the-visionary" className="bg-background text-foreground py-28 md:py-40 px-5 md:px-8 lg:px-14 relative overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 lg:gap-x-6">
          
          <div ref={headerRef} className={`lg:col-span-5 lg:sticky lg:top-28 lg:self-start transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            
            <div className="font-default text-[0.875rem] uppercase tracking-[0.2em] mb-10 flex items-center gap-2" style={{
            color: "var(--primary)"
          }}>
              <span style={{
              color: "var(--primary)"
            }}><br /></span>
              <span>un progetto personale</span>
            </div>

            
            <h2 className="font-default font-bold text-[clamp(3.5rem,8vw,6rem)] leading-[1.0] tracking-tighter text-foreground">&nbsp;Dietro la <span className="font-default italic font-normal" data-ast-id="f:/src/pages/Home/sections/TheVisionary.tsx|sig:a44y9v" data-ast-start="2339" data-ast-end="2617" style={{
              color: 'var(--primary)',
              letterSpacing: '-0.01em'
            }}><br />Visione</span></h2>

            
            <div className="flex items-center gap-2 mt-10 mb-10">
              <span className="block h-px" style={{
              width: "160px",
              backgroundColor: "var(--primary)"
            }} />
              <span className="block h-[6px] w-[6px] rounded-lg" style={{
              backgroundColor: "var(--border)"
            }} />
            </div>

            
            
          </div>

          
          <div ref={gridRef} className="lg:col-span-7">
            <div className="flex flex-col gap-12">
              {chefs.map((chef, i) => <div key={chef.name} data-index={i} className={`group relative bg-card rounded-lg p-6 md:p-10 transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
              transitionDelay: gridVisible ? `${i * 120}ms` : "0ms",
              border: "1px solid var(--border)"
            }}>
                  <div className="flex flex-col md:flex-row gap-10 items-center md:items-start">
                    
                    <div className="flex-1 order-2 md:order-1">
                      {chef.role.includes("Founder") && <Label className="inline-block bg-primary text-primary-foreground mb-4 px-3 py-1 rounded-lg uppercase text-[10px] tracking-widest font-bold border-none">
                          FOUNDER
                        </Label>}
                      
                      <h3 className="font-default font-semibold text-[clamp(1.5rem,3vw,2.5rem)] leading-[1.1] tracking-tight text-foreground">
                        {chef.name}
                      </h3>

                      <p className="font-default text-[0.875rem] uppercase mt-2 font-medium" style={{
                    letterSpacing: "0.1em",
                    color: "var(--primary)"
                  }}>
                        {chef.role}
                      </p>

                      <div className="flex items-center gap-2 mt-6 mb-6">
                        <span className="block h-px" style={{
                      width: "48px",
                      backgroundColor: "var(--primary)"
                    }} />
                      </div>

                      <p className="font-default text-[1.125rem] leading-[1.6] mb-8" style={{
                    color: "var(--muted-foreground)"
                  }}>
                        {chef.bio}
                      </p>

                      {chef.hasSocials && <div className="flex flex-col gap-2 max-w-xs">
                          <Button asChild className="w-full justify-start gap-3 bg-[#0077b5] text-white border-none rounded-lg h-11 px-4">
                            <Link to="https://it.linkedin.com/in/marinela-demrozi-5a5ba3172" newTab>
                              <Linkedin className="size-5" />
                              <span className="font-medium">LinkedIn</span>
                            </Link>
                          </Button>
                        </div>}
                    </div>

                    <div className="w-full md:w-[40%] order-1 md:order-2">
                      <div className="relative overflow-hidden rounded-lg">
                        <div className="aspect-[4/5] w-full overflow-hidden bg-muted">
                          <img src={chef.image} data-wvc-srcset={chef.srcset} data-wvc-sizes={chef.sizes} alt={`${chef.name}, ${chef.role} at MARINELA`} loading="lazy" decoding="async" className="w-full h-full object-cover transition-all duration-500 ease-out group-hover:scale-[1.03] group-hover:saturate-[0.9]" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}